var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-form-page"},[(!_vm.loadingState.initial)?_c('payment-form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }